import React from "react";
import { Chip } from "@mui/material";
import { ShieldCheck } from "@phosphor-icons/react";

/**
 * Marks a step whose readiness checks are being waived by an active override.
 * Shown on every step of the flow so the bypass stays visible next to the
 * failures it is overriding.
 */
const OverrideChip: React.FC = () => (
  <Chip
    icon={<ShieldCheck size={16} weight="duotone" />}
    label="Requirement override active"
    size="small"
    color="warning"
    sx={{ alignSelf: "flex-start" }}
  />
);

export default OverrideChip;
